<script setup>

import { inject } from 'vue';
import Tag from 'primevue/tag';

const getDimension = inject('getDimension');
const getTypeObjet = inject('getTypeObjet');
const getChamp = inject('getChamp');

defineProps({
  donnees: Object
})

const NB_CHAMPS_MAX = 8;

function getInfobulle(champs, groupeVerbal) {
	var listeElements = '';
	var descElement;
	var nbChamps = 1;
	for (const champ of champs) {
		if (nbChamps > NB_CHAMPS_MAX) {
			listeElements += `<li>+ ${champs.length - NB_CHAMPS_MAX} autres éléments...</li>`;
			break;
		}
		if (champ.idChamp) {
			let nomChamp = getChamp(champ.idTypeObjet, champ.idChamp).nom;
			let nomTypeObjet = getTypeObjet(champ.idTypeObjet).nom;
			descElement = `Champ ${nomChamp} du type d\'objet ${nomTypeObjet}`;
		} else if (champ.idDimension) {
			let nomDimension = getDimension(champ.idDimension).nom;
			descElement = `Dimension ${nomDimension}`;
		} else if (champ.idTypeObjetPopule) {
			let nomTypeObjet = getTypeObjet(champ.idTypeObjetPopule).nom;
			descElement = `Population du type d'objet ${nomTypeObjet}`;
		}
		listeElements += `<li>${descElement}</li>`;
		nbChamps++;
	}
	const introduction = `${champs.length} élément(s) ${groupeVerbal} :`;
	const texte = `${introduction}\n<ul>${listeElements}</ul>`;
	return {
		value: texte,
		escape: true
	};
}

</script>

<template>
	<div class="compteurs">
		<Tag v-if="donnees.modifications.champsValeursModifiees.length > 0"
		class="badge valeur-saisie-a-prendre-en-compte"
		rounded
		v-tooltip.left="getInfobulle(
			donnees.modifications.champsValeursModifiees,
			'avec des valeurs modifiées')">
			{{ donnees.modifications.champsValeursModifiees.length }}
		</Tag>
		<Tag v-if="donnees.jeuDonneesCourant.statut !== 'A_JOUR' && donnees.modifications.champsARecalculer.length > 0"
		class="badge valeur-a-recalculer"
		rounded 
		v-tooltip.left="getInfobulle(
			donnees.modifications.champsARecalculer,
			'à recalculer')">
			{{ donnees.modifications.champsARecalculer.length }}
		</Tag>
		<Tag v-if="donnees.champsForces.length > 0"
		class="badge valeur-forcee"
		rounded 
		v-tooltip.left="getInfobulle(
			donnees.champsForces,
			'avec des valeurs forcées')">
			{{ donnees.champsForces.length }}
		</Tag>
		<Tag v-if="donnees.champsEnErreur.length > 0" 
		class="badge valeur-en-erreur"
		rounded 
		v-tooltip.left="getInfobulle(
			donnees.champsEnErreur,
			'avec des valeurs ou une formule en erreur')">
			{{ donnees.champsEnErreur.length }}
		</Tag>
	</div>
</template>

<style scoped>

.compteurs {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-grow: 1;
}

.badge {
	border: solid 1px var(--couleur-bordure);
	border-radius: 20px;
	user-select: none;
	margin: 0px 2px;
	padding: 5px 7px;
	font-weight:700 !important;
	font-size: 8px !important;
}

</style>

